var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filtering-group-warning"},[_vm._v("\n  "+_vm._s(_vm.$getText('CONTACT_TOO_MUCH_FILTERING_GROUP_RESULTS'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }